import { AlarmSetting, AlarmSettingFns, DigitalAlarmSetting } from './alarm-setting';
import { MotorAlarmSetting, MotorAlarmSettingFns } from './motor-alarm-setting';
import { ChannelType } from './channel-type';
import { SystemAlarmSetting, SystemAlarmSettingFns } from './system-alarm-setting';

export class ChannelFcuData {
    id: string;
    channelId: string;
    fcuChannelId: string;
    channelType: ChannelType;
    fcuNo: number;
    measurableRange: {
        max: number;
        min: number;
    };
    normalRange: {
        max: number;
        min: number;
    };
    scale: number;
    fixedDigit: number;
    inputData: {
        fuInputAddress: {
            fuNo: number;
            slotNo: number;
            pin: number;
            pinCount: number;
        };
        memoryInputAddress: {
            address: number;
            mask: number;
        };
        misc: {
            digitalInputFilter: number;
            hysteresis: number;
        };
    };
    outputData: {
        fuOutputAddress: {
            fuNo: number;
            slotNo: number;
            pin: number;
            pinCount: number;
        };
        memoryOutputAddress: {
            address: number;
            mask: number;
        };
        misc: {
            setPoint: 0;
            signalType: SignalType;
            signalWidth: 0;
            hysteresisForOpen: number;
            hysteresisForClose: number;
        };
    };
    digitalAlarmSetting: DigitalAlarmSetting;
    motorChannelSetting: MotorAlarmSetting;
    alarmSettingVeryHigh: AlarmSetting;
    alarmSettingHigh: AlarmSetting;
    alarmSettingLow: AlarmSetting;
    alarmSettingVeryLow: AlarmSetting;
    alarmSettingSensorFail: AlarmSetting;
    alarmSettingFeedbackError: AlarmSetting;
    systemAlarmSetting: SystemAlarmSetting;
    standardNameId: string;
    manualRepose?: boolean;
}

export enum SignalType {
    UNDEFINED = '',
    CONTINUOUS = 'Continuous',
    SINGLE = 'Single',
}

export const ChannelFcuDataFns = {
    create,
};

function create(setToNull = false): ChannelFcuData {
    return {
        id: '',
        channelId: '',
        fcuChannelId: null,
        channelType: null,
        fcuNo: setToNull ? null : 1,
        measurableRange: setToNull
            ? null
            : {
                  max: 0,
                  min: 0,
              },
        normalRange: setToNull
            ? null
            : {
                  max: 0,
                  min: 0,
              },
        fixedDigit: setToNull ? null : 0,
        scale: setToNull ? null : 1,
        inputData: setToNull
            ? null
            : {
                  fuInputAddress: {
                      fuNo: 0,
                      slotNo: 0,
                      pin: 0,
                      pinCount: 0,
                  },
                  memoryInputAddress: {
                      address: 0,
                      mask: 0,
                  },
                  misc: {
                      digitalInputFilter: 0,
                      hysteresis: 0,
                  },
              },
        outputData: setToNull
            ? null
            : {
                  fuOutputAddress: {
                      fuNo: 0,
                      slotNo: 0,
                      pin: 0,
                      pinCount: 0,
                  },
                  memoryOutputAddress: {
                      address: 0,
                      mask: 0,
                  },
                  misc: {
                      setPoint: 0,
                      signalType: SignalType.UNDEFINED,
                      signalWidth: 0,
                      hysteresisForOpen: 0,
                      hysteresisForClose: 0,
                  },
              },
        digitalAlarmSetting: setToNull ? null : AlarmSettingFns.createDigital(),
        motorChannelSetting: setToNull ? null : MotorAlarmSettingFns.create(),
        alarmSettingVeryHigh: setToNull ? null : AlarmSettingFns.create(),
        alarmSettingHigh: setToNull ? null : AlarmSettingFns.create(),
        alarmSettingLow: setToNull ? null : AlarmSettingFns.create(),
        alarmSettingVeryLow: setToNull ? null : AlarmSettingFns.create(),
        alarmSettingSensorFail: setToNull ? null : AlarmSettingFns.create(),
        alarmSettingFeedbackError: setToNull ? null : AlarmSettingFns.create(),
        systemAlarmSetting: setToNull ? null : SystemAlarmSettingFns.createDefault(),
        standardNameId: setToNull ? null : '0',
    };
}
